import React from 'react'

export default function Empty({ children }) {
    return (
        <h1 className='h-full flex justify-center items-center mx-10 py-6 text-3xl text-gray-400'>
            {children}
        </h1>
    )
}
